import React from 'react';
import { getIcon, ICON_OPTIONS } from '../../lib/icons';
import { EField, FieldRow } from './EditableField';

export default function SectionPillars({ section_label = '', title = '', subtitle = '', items = [], mode = 'view', onChange }) {
  const updateItem = (i, key, val) => {
    const next = items.map((it, idx) => idx === i ? { ...it, [key]: val } : it);
    onChange?.({ items: next });
  };
  const addItem = () => onChange?.({ items: [...items, { title: 'New Pillar', subtitle: 'Subtitle', color: '#c4a144', icon: 'sparkles' }] });
  const removeItem = (i) => onChange?.({ items: items.filter((_, idx) => idx !== i) });

  return (
    <section className="py-24 bg-ee-bg">
      <div className="ee-container">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          {mode === 'edit' ? (
            <>
              <FieldRow label="Section Label"><EField value={section_label} onChange={(v) => onChange?.({ section_label: v })} mode={mode} /></FieldRow>
              <FieldRow label="Title"><EField value={title} onChange={(v) => onChange?.({ title: v })} mode={mode} /></FieldRow>
              <FieldRow label="Subtitle"><EField multiline value={subtitle} onChange={(v) => onChange?.({ subtitle: v })} mode={mode} /></FieldRow>
            </>
          ) : (
            <>
              <div className="text-xs tracking-[0.3em] text-gold mb-3 uppercase">{section_label}</div>
              <h2 className="hero-title text-4xl md:text-5xl text-white mb-4">{title}</h2>
              <p className="text-ee-text2">{subtitle}</p>
            </>
          )}
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((it, i) => {
            const Icon = getIcon(it.icon);
            return (
              <div key={i} className="ee-card ee-card-hover p-8 group">
                <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110" style={{ background: `${it.color}22`, border: `1px solid ${it.color}55` }}>
                  <Icon size={26} style={{ color: it.color }} />
                </div>
                <h3 className="text-2xl font-serif text-white mb-2">
                  <EField value={it.title} onChange={(v) => updateItem(i, 'title', v)} mode={mode} />
                </h3>
                <p className="text-ee-text2">
                  <EField value={it.subtitle} onChange={(v) => updateItem(i, 'subtitle', v)} mode={mode} />
                </p>
                {mode === 'edit' && (
                  <div className="mt-4 grid grid-cols-2 gap-2">
                    <FieldRow label="Color"><EField value={it.color} onChange={(v) => updateItem(i, 'color', v)} mode={mode} /></FieldRow>
                    <FieldRow label="Icon">
                      <select value={it.icon} onChange={(e) => updateItem(i, 'icon', e.target.value)} className="w-full bg-ee-card2 border border-gold/30 rounded-md px-2 py-1 text-white">
                        {ICON_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                      </select>
                    </FieldRow>
                    <button onClick={() => removeItem(i)} className="col-span-2 text-xs text-red-400 hover:text-red-300">Remove pillar</button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {mode === 'edit' && (
          <div className="text-center mt-6">
            <button onClick={addItem} className="text-xs px-3 py-1.5 rounded border border-gold/40 text-gold hover:bg-gold/10">+ Add Pillar</button>
          </div>
        )}
      </div>
    </section>
  );
}
